import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ActionSheetController, ModalController } from '@ionic/angular';
import { ViewApplicationDetailModel } from 'src/app/model/ViewApplicationDetailModel';
import { ViewApplicationService } from 'src/app/services/view-application.service';
import { ViewPdfComponent } from '../../view-pdf/view-pdf.component';
import { AuditTrailService } from 'src/app/audit-trail/audit-trail.service';
import { ProgressSpinnerComponent } from 'src/app/progress-spinner/progress-spinner.component';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { ViewProfileDocumentComponent } from 'src/app/audit-trail/profile-details/view-profile-document/view-profile-document.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ViewImageOnlyComponent } from '../../view-image-only/view-image-only.component';
import { AddNomineeOfApplicationService } from 'src/app/services/add-nominee-of-application.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { error } from 'console';
import { ConfirmDataModalComponent } from '../../confirm-data-modal/confirm-data-modal.component';

@Component({
  selector: 'app-secure-add-nominee-form',
  templateUrl: './add-nominee-form.component.html',
  styleUrls: ['./add-nominee-form.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AddNomineeFormComponent implements OnInit {

  
	nomineeRelationship: string= "";
	nomineeName: string= "";
	nomineeMobileNumber: string= "";
	nomineeEmailId: string= "";
  genderNames: string[] = ["MALE","FEMALE"];
  isReadOnly: boolean = false;

  newNomineeName :string="";
	newNomineeGender :string="";
	newNomineeAge :string="";
	newNomineePanNumber :string="";
	newNomineeRelationWtApplicant :string="";
	isNewNomineeNameAdd :string="";
	newNomineeNameAddOrderFile :string | ArrayBuffer;
  newNomineeNameAddDocFile :string | ArrayBuffer;
  applicationNo :string="";

  selectedFile: File;
  selectedNomineeDocFile: File;
  orderDocFile: string | ArrayBuffer;
  orderDocFileForView: string | ArrayBuffer;
  orderDocFileName: string;
  docNameWithoutExtnsn: string;

  nomineeDocFile: string | ArrayBuffer;
  nomineeDocFileForView: string | ArrayBuffer;
  nomineeDocFileName: string;
  nomineedocNameWithoutExtnsn: string;

  form: FormGroup = new FormGroup({});

  data: ViewApplicationDetailModel;
  applicationId: number;
  isLoading: boolean = false;
  manualRejectedQuestions: any[] = [];
	documents: any[] = [];
	verifiedStatus: any[] = [];
  documentName: string = "";
  profileDetails: any[] = [];
  areQuestionsNotAnswered: boolean;
  activeLang: string = "en";
  viewEnMr: string = "View";
  cancelEnMr: string = "Cancel";
  editEnMr: string = "Edit";
  progressSpinnerDialog: any = null;
  downloadedBatches: string[] = [];
  pageMode: string;

  
  constructor(private route: ActivatedRoute, private addNomineeService: AddNomineeOfApplicationService, 
    private modalCtrl: ModalController, private auditTrailService: AuditTrailService, 
    private router: Router, public actionSheetController: ActionSheetController,
    private dialog: MatDialog, private domSanitizer: DomSanitizer ,private _snackBar: MatSnackBar) { }

  ngOnInit(): void {  

    this.form = new FormGroup({
      newNomineeName: new FormControl(null, [Validators.required, Validators.pattern(/^[a-zA-Z& ]+$/)]),
      newNomineeGender: new FormControl(null, Validators.required),
      newNomineeAge: new FormControl(null, [Validators.required, Validators.min(0), Validators.pattern('^[0-9]*$'), Validators.max(100)]),
      newNomineePanNumber: new FormControl(null, [Validators.required, Validators.maxLength(10)]),
      newNomineeRelationWthApp: new FormControl(null, [Validators.required, Validators.pattern(/^[a-zA-Z& ]+$/)]),
      orderFile: new FormControl(null, Validators.required),
      nomineeDocFile: new FormControl(null, Validators.required),
    });

    this.route.params.subscribe((params: Params) => {
      this.applicationId = +params["applicationId"];
      
      this.isLoading = true;
      this.addNomineeService.fetchDetailView(this.applicationId)
      .subscribe(async (data: any)=>{
        this.isLoading = false;
        if(data.status === 'SUCCESS') {
          this.data = data;
          console.log("All Data >>>>>>>>>>>>>>>>>>>>>>>>",this.data);
          this.nomineeName = data.nomineeName;
          this.nomineeRelationship = data.nomineeRelationship;
          this.nomineeMobileNumber = data.nomineeMobileNumber;
          this.nomineeEmailId = data.nomineeEmailId;
          this.applicationNo = data.applicationNo;

          if(data.isNewNomineeNameAdd === "Y"){
            this.isReadOnly = true;
            this.newNomineeNameAddOrderFile = data.newNomineeNameAddOrderFile;
            this.newNomineeNameAddDocFile = data.newNomineeNameAddDocFile;
            this.form.setValue({
              newNomineeName: this.form.get('newNomineeName').setValue(data.newNomineeName),
              newNomineeGender: this.form.get('newNomineeGender').setValue(data.newNomineeGender),
              newNomineeAge: this.form.get('newNomineeAge').setValue(data.newNomineeAge),
              newNomineePanNumber: this.form.get('newNomineePanNumber').setValue(data.newNomineePanNumber),
              newNomineeRelationWthApp: this.form.get('newNomineeRelationWthApp').setValue(data.newNomineeRelationWtApplicant),
            });
          }else{
            this.form.setValue({
              newNomineeName: data.nomineeName !=null ? this.form.get('newNomineeName').setValue(data.nomineeName) : this.form.get('newNomineeName').setValue(data.newNomineeName),
              newNomineeRelationWthApp: data.nomineeRelationship != null ? this.form.get('newNomineeRelationWthApp').setValue(this.nomineeRelationship) : this.form.get('newNomineeRelationWthApp').setValue(data.newNomineeRelationWtApplicant),
            });
          }
        }
        else {
          this.addNomineeService.errorToast(data.errorMessage);
        }
      }, error => {
        this.isLoading = false;
        this.addNomineeService.errorToast(error?.error?.errorMessage||error?.error?.message);
      });
    });
  }

  async viewFile(fileType, file) {
    const modal = await this.modalCtrl.create({
        component: ViewPdfComponent,
            componentProps: {
            base64: file,
            documentName: fileType,
            fileName: fileType+"_"+this.applicationNo+"_"+new Date().getTime()+".pdf"
        }
    });
    modal.present();
  }

  showGender(o1: any, o2: any) {
    if(o1 && o2 && o1 == o2) {
      return o1;
    }
    else {
      return "";
    }
  }

  downloadSelectedFile(){
    if(this.orderDocFile !== undefined || this.orderDocFile !== null){
      this.downloadFile(this.orderDocFile, this.orderDocFileName);
    }else{
      return this.addNomineeService.errorToast("Please upload the File");
    }
  }

  downloadSelectedFile2(){
    if(this.nomineeDocFile !== undefined || this.nomineeDocFile !== null){
      this.downloadFile(this.nomineeDocFile, this.nomineeDocFileName);
    }else{
      return this.addNomineeService.errorToast("Please upload the File");
    }
  }

  downloadDocumentFile(){


    // if(this.form.value.otherChargeName !== "MAINTENANCE_CHARGE"){
    //   return this.addNomineeService.errorToast("Invalid Charges Type");
    // }

    // if(this.form.value.key === null && this.form.value.key === undefined){
    //   return this.addNomineeService.errorToast("Tenement Config Key is not found");
    // }

    // console.log("this.form.value.key, this.form.value.tenementKey >> ", this.form.value.key, " ", this.form.value.tenementKey);

    // this.addNomineeService.getDocumentFile(this.form.value.key, this.form.value.tenementKey)
    // .subscribe((data) => {
    //   console.log(data);
    //   if(data.status === "SUCCESS"){
    //     console.log("File Name >> ",data );

    //     console.log("data.corrigendumFile >> ", data.corrigendumFile);
    //     console.log("data.corrigendumFileName >> ", data.corrigendumFileName);
    //     if((data.corrigendumFile === undefined || data.corrigendumFile === null) 
    //       && (data.corrigendumFileName === undefined || data.corrigendumFileName === null)){
    //       return this.addNomineeService.errorToast("Unable to donwload File.");
    //     }else{
    //       this.downloadFile(data.corrigendumFile, data.corrigendumFileName);
    //       // this.showFile(data.corrigendumFile, data.corrigendumFileName);
    //     }
    //   }else{
    //     this.addNomineeService.errorToast("No File Found");
    //   }
    // }, (error) => {
    //   this.addNomineeService.errorToast(
    //     error?.error?.errorMessage || error?.error?.message
    //   );
    // });
  }

  downloadFile(base64: string | ArrayBuffer, fileName: string) {
    // Logging inputs
    
  
    // Convert base64 or ArrayBuffer to a Blob
    let blob: Blob;
  
    if (typeof base64 === "string") {
      // Remove any prefix from the base64 string if necessary
      const base64Data = base64.split(",").pop() || "";
      const byteCharacters = atob(base64Data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      blob = new Blob([byteArray], { type: "application/pdf" });
    } else {
      blob = new Blob([base64], { type: "application/pdf" });
    }
  
    // Create a URL for the Blob and initiate download
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
  
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  
    // Revoke the object URL after the download
    window.URL.revokeObjectURL(url);
  }
  

  cancel(){
    this.router.navigate(['secure/add-nominee']);
  }

  validatePANFormat(){

    const isValidFormat = /^[A-Za-z]{5}\d{4}[A-Za-z]$/.test(this.form.get('newNomineePanNumber').value);
    if (!isValidFormat) {
        return this.addNomineeService.errorToast("Invalid PAN number format");
    } else {
    }
  }

  onFileSelect(event) {
    console.log("In onFileSelect >> ");
    if (event.target.files[0].size < 2 * 1024 * 1024) {
      this.selectedFile = event.target.files[0];
      if (this.selectedFile && this.selectedFile.type === "application/pdf") {
        const reader = new FileReader();
        reader.readAsDataURL(this.selectedFile);
        reader.onload = () => {
          this.orderDocFile = reader.result;
          this.orderDocFileForView = this.orderDocFile;
          const fileNameParts = this.selectedFile.name.split(".");
          this.orderDocFileName = this.selectedFile.name;
          const fileNameWithoutExtension = fileNameParts[0];
          this.docNameWithoutExtnsn = fileNameWithoutExtension;
        };
      } else {
        this.selectedFile = null;
        this.orderDocFile = null;
        this._snackBar.open("Please select a valid PDF file.", "Close", {
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: "error-toast",
          duration: 3 * 1000,
        });
      }
    } else {
      this.selectedFile = null;
      this.orderDocFile = null;
      this._snackBar.open("File size exceeds 2MB.", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: 3 * 1000,
      });
    }
  }

  onFileSelect2(event1) {
    console.log("In onFileSelect2 >> ");
    if (event1.target.files[0].size < 5 * 1024 * 1024) {
      this.selectedNomineeDocFile = event1.target.files[0];
      if (this.selectedNomineeDocFile && this.selectedNomineeDocFile.type === "application/pdf") {
        const reader = new FileReader();
        reader.readAsDataURL(this.selectedNomineeDocFile);
        reader.onload = () => {
          this.nomineeDocFile = reader.result;
          this.nomineeDocFileForView = this.nomineeDocFile;
          const fileNameParts = this.selectedNomineeDocFile.name.split(".");
          this.nomineeDocFileName = this.selectedNomineeDocFile.name;
          this.nomineedocNameWithoutExtnsn = fileNameParts[0];
        };
      } else {
        this.selectedNomineeDocFile = null;
        this.nomineeDocFile = null;
        this._snackBar.open("Please select a valid PDF file.", "Close", {
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: "error-toast",
          duration: 3 * 1000,
        });
      }
    } else {
      this.selectedNomineeDocFile = null;
      this.nomineeDocFile = null;
      this._snackBar.open("File size exceeds 5MB.", "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: 3 * 1000,
      });
    }
  }

  async Submit(){

    console.log("In Submit.");

    if(this.form.get('newNomineeName').value === null || this.form.get("newNomineeName").value === undefined || this.form.get("newNomineeName").value.trim() === ''){
      return this.addNomineeService.errorToast("Please provide Nominee Name ");
    }else{
      if(this.form.get('newNomineeName').value !==null || this.form.get('newNomineeName').value !== undefined){
        const value = this.form.get('newNomineeName').value;
        if (/^[a-zA-Z\s]*$/.test(value)) {
        } else {
          return this.addNomineeService.errorToast("Please enter correct Nominee Name");
        }
      }
    }

    if(this.form.get('newNomineeGender').value === null || this.form.get("newNomineeGender").value === undefined || this.form.get("newNomineeGender").value === "Select"){
      return this.addNomineeService.errorToast("Please select Nominee Gender ");
    }
    if(this.form.get('newNomineeAge').value === null || this.form.get("newNomineeAge").value === undefined){
      return this.addNomineeService.errorToast("Please provide Nominee Age ");
    }
    if(this.form.get('newNomineePanNumber').value === null || this.form.get("newNomineePanNumber").value === undefined){
      return this.addNomineeService.errorToast("Please provide Nominee PAN Number ");
    }else{
      const isValidFormat = /^[A-Za-z]{5}\d{4}[A-Za-z]$/.test(this.form.get('newNomineePanNumber').value);
      if (!isValidFormat) {
          return this.addNomineeService.errorToast("Invalid PAN number format");
      } else {
      }
    }

    if(this.form.get('newNomineeRelationWthApp').value === null || this.form.get("newNomineeRelationWthApp").value === undefined || this.form.get("newNomineeRelationWthApp").value.trim() === ''){
      return this.addNomineeService.errorToast("Please provide Nominee Relation with Applicant");
    }else{
      if(this.form.get('newNomineeRelationWthApp').value !==null || this.form.get('newNomineeRelationWthApp').value !== undefined){
        const value = this.form.get('newNomineeRelationWthApp').value;
        if (/^[a-zA-Z\s]*$/.test(value)) {
        } else {
          return this.addNomineeService.errorToast("Please enter correct Nominee Relation with Applicant");
        }
      }
    }
    
    if(this.form.get('orderFile').value == null || this.form.get("orderFile").value === undefined){
      return this.addNomineeService.errorToast("Please provide Nominee Order File ");
    }

    if(this.form.get('nomineeDocFile').value == null || this.form.get("nomineeDocFile").value === undefined){
      return this.addNomineeService.errorToast("Please provide Nominee Doc File ");
    }

    const modal = await this.modalCtrl.create({
      component: ConfirmDataModalComponent,
      componentProps: {
          modalHeader: "Confirm Nominee Details",
          base64: this.orderDocFile != null? this.orderDocFile : null,
          nomineeName: this.form.get('newNomineeName').value,
          nomineeGender: this.form.get('newNomineeGender').value,
          nomineeAge: this.form.get('newNomineeAge').value,
          nomineePanNumber: this.form.get('newNomineePanNumber').value,
          nomineeRelationWthApp: this.form.get('newNomineeRelationWthApp').value,
          nomineeDocBase64: this.nomineeDocFile != null? this.nomineeDocFile : null,
      }
    });
    modal.present();

    const { data } = await modal.onWillDismiss();
    
    if (data != null && data == "Submit") {
      if(this.form.valid){
        this.addNomineeService.saveNomineeDtls(this.applicationId, this.form.get('newNomineeName').value, 
            this.form.get('newNomineeGender').value, this.form.get('newNomineeAge').value,
            this.form.get('newNomineePanNumber').value, this.orderDocFile, this.nomineeDocFile, this.form.get('newNomineeRelationWthApp').value
        ).subscribe((data) =>{
          if(data.status === "SUCCESS"){
            console.log(data);
            // this.router.navigate(['secure/add-nominee']);
            this.ngOnInit();
            this.addNomineeService.successToast(data.successMsg);
          }else{
            this.addNomineeService.errorToast(data.errorMessage);
          }
        }, error => {
          console.error("Error:", error);
          this.addNomineeService.errorToast(error);
        });
      }
    }
  }

  async generateUnsignedPOL(applicationId: number) {
    this.isLoading = true;

    this.addNomineeService.generateUnsignedPOL(applicationId).subscribe((data) => {
      this.isLoading = false;
        if(data.status === 'SUCCESS') {
          this.downloadFile(data.base64File, data.fileName);
          // this.ngOnInit();
        }  
        else {
          this.addNomineeService.errorToast(data.errorMessage, 18000);
        }
      }, (error) => {
        console.log(error);
        this.isLoading = false;
      }
    );
  }

  async generateUnsignedAllotmentLetter(applicationId: number) {
    this.isLoading = true;

    this.addNomineeService.generateUnsignedAllotmentLetter(applicationId).subscribe((data) => {
        this.isLoading = false;
        if(data.status === 'SUCCESS') {
          this.downloadFile(data.base64File, data.fileName);
          // this.ngOnInit();
        }  
        else {
          this.addNomineeService.errorToast(data.errorMessage, 18000);
        }
      }, (error) => {
        console.log(error);
        this.isLoading = false;
      }
    );
  }

  async generateUnsignedPossessionLetter(applicationId: number) {
    this.isLoading = true;
    
    this.addNomineeService.generateUnsignedPossessionLetter(applicationId).subscribe((data) => {
        this.isLoading = false;
        if(data.status === 'SUCCESS') {
          this.downloadFile(data.base64File, data.fileName);
          // this.ngOnInit();
        }  
        else {
          this.addNomineeService.errorToast(data.errorMessage, 18000);
        }
      }, (error) => {
        console.log(error);
        this.isLoading = false;
      }
    );
  }
  
  async successToast() {
      await this._snackBar.open(
          " Letters Successfully Downloaded",
          "Close", {
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: "success-toast",
          duration: 3 * 1000,
          }
      );
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: dur ? dur : 3 * 1000,
    });
  }
}
